// sites.$siteId.duerp-versions.tsx — T075
// Route : /sites/:siteId/duerp-versions — versions DUERP.
// Guard : accès au site (CONSULTATION ou MODIFICATION) — le parent SiteRoute vérifie canAccessSite.
// Les actions d'écriture (créer, valider) sont gardées dans DuerpVersionsPage.

import { createFileRoute } from "@tanstack/react-router";

import { DuerpVersionsPage } from "@/presentation/pages/DuerpVersionsPage";

import { Route as SiteRoute } from "./sites.$siteId";

export const Route = createFileRoute("/sites/$siteId/duerp-versions")({
  component: function DuerpVersionsComponent() {
    const { siteId } = Route.useParams();
    const { site } = SiteRoute.useLoaderData();
    return <DuerpVersionsPage siteId={siteId} regionId={site.regionId} />;
  },
});
